import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  createMainModuleSuccess,
  createMainModuleFailure,
  getMainModuleListSuccess,
  getMainModuleListFailure,
  updateMainModuleSuccess,
  updateMainModuleFailure,
  updateStatusMainModuleFailure,
  updateStatusMainModuleSuccess,
  viewMainModuleSuccess,
  viewMainModuleFailure,
} from "../../actions";
import {
  CREATE_MAIN_MODULE,
  GET_MAIN_MODULE_LIST,
  UPDATE_MAIN_MODULE,
  UPDATE_STATUS_MAIN_MODULE,
  VIEW_MAIN_MODULE,
} from "../../Actions/types";
import api from "../../../helper/api";

function* createMainModule(action) {
  try {
    const response = yield api.post(
      "/admin/mainModule/add-mainModule",
      action?.payload?.form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        createMainModuleSuccess({ createMainModuleData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(createMainModuleFailure({ createMainModuleError: e }));
  }
}

function* getMainModuleList(action) {
  try {
    const response = yield api.get(
      "/admin/category/main-module-listing",
      
    );
    if (response?.status === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(
        getMainModuleListSuccess({ getMainModuleListData: response?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(getMainModuleListFailure({ getMainModuleListError: e }));
  }
}

function* updateMainModule(action) {
  const form = {
    title: action?.payload?.form?.title,
    description: action?.payload?.form?.description,
    image: action?.payload?.form?.image,
    categories: action?.payload?.form?.categories,
  };
  try {
    const response = yield api.put(
      `/admin/mainModule/edit-mainModule/${action?.payload?.form?.id}`,
      form,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateMainModuleSuccess({ updateMainModuleData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateMainModuleFailure({ updateMainModuleError: e }));
  }
}

function* updateStatusMainModule(action) {
  try {
    const response = yield api.put(
      `/admin/mainModule/change-status/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateStatusMainModuleSuccess({
          updateStatusMainModuleData: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(
      updateStatusMainModuleFailure({ updateStatusMainModuleError: e })
    );
  }
}

function* viewMainModule(action) {
  try {
    const response = yield api.get(
      `/admin/mainModule/view-mainModule/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        viewMainModuleSuccess({ viewMainModuleData: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewMainModuleFailure({ viewMainModuleError: e }));
  }
}

function* createMainModuleWatcher() {
  yield takeLatest(CREATE_MAIN_MODULE, createMainModule);
}

function* getMainModuleListWatcher() {
  yield takeLatest(GET_MAIN_MODULE_LIST, getMainModuleList);
}
function* updateMainModuleWatcher() {
  yield takeLatest(UPDATE_MAIN_MODULE, updateMainModule);
}
function* updateStatusMainModuleWatcher() {
  yield takeLatest(UPDATE_STATUS_MAIN_MODULE, updateStatusMainModule);
}
function* viewMainModuleWatcher() {
  yield takeLatest(VIEW_MAIN_MODULE, viewMainModule);
}

export default function* mainModuleManagementSaga() {
  yield all([
    createMainModuleWatcher(),
    getMainModuleListWatcher(),
    updateMainModuleWatcher(),
    updateStatusMainModuleWatcher(),
    viewMainModuleWatcher(),
  ]);
}
